<template>
  <div>
    <NewsItem />
    <div class="container" id="validation-carte">
      <h1 v-translate>Confirmation</h1>
      <div class="box">
        <div class="box__inner">
          <h2 class="confirmation__title">
            <img src="../assets/ui/checked.svg" class="confirmation__title-icon" alt="">
            Rendez-vous le {{ this.$store.state.selectedDate }} {{ t('à')}} {{ this.$store.state.selectedTime }}
          </h2>
          <div class="confirmation__layout">
            <div>
              <label for="code-de-confirmation" class="confirmation__code-label">Votre code de confirmation:</label>
              <div class="confirmation__code-input_container">
                <input
                  ref="confirmation"
                  readonly
                  id="code-de-confirmation"
                  type="text"
                  :value="$store.state.confirmationToken"
                  class="confirmation__code-input">
                <button @click="onCopy" type="button" class="confirmation__copy-button">
                  <img src="../assets/ui/copy.svg" alt="">
                </button>
                <p :class="['confirmation__copy-message', isCopied && 'is-copied']">Copié!</p>
              </div>
              <div class="confirmation__alert">
                <p>Veuillez conserver ce code de confirmation. Celui-ci vous permettra de supprimer ou de modifier votre rendez-vous via cet outil de réservation.</p>
              </div>
            </div>
            <div class="confirmation__information-list">
              <div class="confirmation__information">
                <span class="confirmation__information-title">Nr. de la carte SIVEC</span>
                <span>{{ this.$store.state.sivecNumber }}</span>
              </div>
              <div class="confirmation__information" v-if="this.$store.state.plateNumber && this.$store.state.plateNumber.length > 0">
                <span class="confirmation__information-title">Numéro de plaque</span>
                <span>{{ this.$store.state.plateNumber }}</span>
              </div>
              <div class="confirmation__information" v-if="this.$store.state.vehicleType && this.$store.state.vehicleType.length > 0">
                <span class="confirmation__information-title">Type de véhicule</span>
                <span>{{ this.$store.state.vehicleType }}</span>
              </div>
              <div class="confirmation__information" v-if="this.$store.state.phone && this.$store.state.phone.length > 0">
                <span class="confirmation__information-title">Numéro de téléphone</span>
                <span>{{ this.$store.state.phone }}</span>
              </div>
              <div class="confirmation__information" v-if="this.$store.state.email && this.$store.state.email.length > 0">
                <span class="confirmation__information-title">Adresse e-mail</span>
                <span>{{ this.$store.state.email }}</span>
              </div>
            </div>
          </div>
          <p class="confirmation__contact-message">
            <span v-if="this.$store.state.email && this.$store.state.email.length > 0">Une confirmation vous a été envoyée par email. <br></span> Apportez la confirmation le jour du rendez-vous (papier ou sur le portable)
          </p>
          <div class="actions">
            <button v-on:click="editAppointment" type="button" class="button button--light">
              <img src="../assets/ui/arrow-back-dark.svg"  alt="">
              Modifier
            </button>
            <button onclick="window.print();return false;" class="button">
              <img src="../assets/ui/print.svg"  alt="">
              imprimer
            </button>
          </div>
        </div>
      </div>
      <div class="confirmation__footer">
        <a href="/" class="confirmation__footer-link">
          <img src="../assets/ui/arrow-back-dark.svg" class="confirmation__footer-link-icon"  alt="">
          Retour vers page d'accueil
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import NewsItem from './NewsItem'

export default {
  name: 'Confirmation',
  components: {NewsItem},
  data () {
    return ({
      isCopied: false,
      newsItems: [],
    })
  },
  methods: {
    onCopy() {
      const confirmationInput = document.getElementById('code-de-confirmation');
      if (confirmationInput) {
        confirmationInput.focus();
        navigator.clipboard.writeText(confirmationInput.value);
        this.toggleCopyMessage();
      }
    },
    toggleCopyMessage () {
      this.isCopied = true
      setTimeout(() => { this.isCopied = false }, 1000)
    },
    editAppointment () {
      this.invalidConfirmationCode = false
      this.isConfirmationCodeChecked = true;

      this.numberValidated = true;

      this.$store.commit('changeData', {
        type: 'summarySection',
        value: false,
      });

      this.$store.commit('changeData', {
        type: 'confirmation',
        value: false,
      });

      this.$store.commit('changeData', {
        type: 'isExistingAppointment',
        value: true,
      });

      this.$store.commit('changeData', {
        type: 'sivecNumberConfirmation',
        value: true,
      });

      this.$store.commit('changeData', {
        type: 'dateSelection',
        value: true,
      });
    },
  }
}

</script>

<style scoped lang="scss">
@import "src/assets/scss/button";

body::after{
  background-color: #fff;
}

.container {
  margin-bottom: 100px;
  position: relative;
  padding-top: 0.67em;

  &::before {
    content: "";
    background-color: var(--green--light);
    position: absolute;
    top: 0;
    right: -50vw;
    bottom: -500px;
    left: -50vw;
    z-index: -1;
  }
}

@media only screen and (max-width: 500px) {
  .container {
    margin-bottom: 50px;
  }
}

.box {
  background-color: var(--green--dark);
  border-radius: 4px;
  display: flex;
  align-items: center;
  min-height: 370px;
  position: relative;
}

@media print {
  .news__container{
    display: none;
  }

  .box {
    background-color: white;
  }

  .box::before {
    background-color: white;
  }

  .box__inner {
    padding: 0;
  }
}

.box__inner {
  margin: 0 auto;
  max-width: 850px;
  padding: var(--xlarge) var(--xmedium);
}

@media only screen and (max-width: 500px) {
  .box__inner {
    padding: var(--xlarge) var(--medium);
  }
}

h1 {
  color: var(--green--dark);
  font-size: 64px;
  text-align: center;
}

@media only screen and (max-width: 500px) {
  h1 {
    font-size: 38px;
  }
}

@media print {
  h1 {
    color: black;
    font-size: 30px;
    margin: 0;
    padding: 0;
  }
}

h2 {
  color: white;
  margin-top: 0;
  text-align: center;
}

@media only screen and (max-width: 500px) {
  h2 {
    font-size: 26px;
    text-align: left;
  }
}

@media print {
  h2 {
    font-size: 26px;
    color: black;
    text-align: left;
  }
}

p {
  color: white;
}

@media print {
  p {
    color: black;
  }
}

table {
  width: 100%;
}

table th,
table td {
  color: white;
  text-align: left;
}

@media print {
  table th,
  table td {
    color: black;
    font-size: 24px;
  }
}

@media only screen and (max-width: 500px) {
  table tr {
    display: flex;
    flex-direction: column;
    padding: 10px 0;
  }

}

.actions {
  padding-top: 40px;
  margin: 0 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.actions::before {
  content: '';
  border-top: 1px solid var(--green--light);
  position: absolute;
  top: 0;
  right: -100px;
  left: -100px;
}

@media only screen and (max-width: 900px) {
  .actions::before {
    right: 0;
    left: 0;
  }
}

@media only screen and (max-width: 750px) {
  .actions {
    display: grid;
    grid-template-rows: 1fr 1fr;
    justify-content: center;
    gap: 15px;
    margin: 40px 0 0;
  }
}

.confirmation__layout {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 120px;
}

@media only screen and (max-width: 900px) {
  .confirmation__layout {
    display: block;
  }
}

@media print {
  .confirmation__layout {
    display: block;
  }

  .actions {
    display: none;
  }
}

.confirmation__code-label {
  display: block;
  font-weight: bold;
  color: white;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.confirmation__code-input {
  appearance: none;
  border: none;
  border-radius: 50px;
  color: var(--green--dark);
  font-size: 26px;
  font-weight: bold;
  line-height: 32px;
  margin-bottom: 30px;
  padding: 8px;
  text-align: center;
  width: 100%;
}

@media print {
  .confirmation__code-input {
    margin: 0;
    padding: 0;
    color: black;
  }
}

.confirmation__alert {
  border: 1px solid white;
  border-radius: 36px 0 0 0;
  margin-bottom: var(--medium);
  padding: 0 10px 0 45px;
  position: relative;
}

.confirmation__alert::after {
  content: '';
  background: url("../assets/ui/exclamation.svg") center center/21px no-repeat, var(--orange);
  border-top-left-radius: 100px;
  border-bottom-right-radius: 100px;
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: -1px;
  width: 32px;
}

.confirmation__information-title {
  display: block;
  font-weight: bold;
}

.confirmation__information-list {
  color: white;
}

@media print {
  .confirmation__information-list {
    color: black;
  }
}

.confirmation__information {
  margin-bottom: var(--medium);
}

.confirmation__contact-message {
  margin-bottom: var(--large);
}

.confirmation__title {
  position: relative;
  text-align: left;
}

@media only screen and (max-width: 900px) {
  .confirmation__title {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.confirmation__title-icon {
  position: absolute;
  top: 10px;
  left: -55px;
}

@media only screen and (max-width: 900px) {
  .confirmation__title-icon {
    margin-bottom: 30px;
    position: relative;
    left: 0;
  }
}

.confirmation__code-input_container {
  position: relative;
}

.confirmation__copy-button {
  display: block;
  position: absolute;
  right: 26px;
  top: 11px;
}

.confirmation__copy-message {
  background-color: var(--green--light);
  border-radius: 6px;
  color: var(--green--dark);
  padding: 5px 15px;
  position: absolute;
  left: 50%;
  bottom: 100%;
  opacity: 0;
  transform: translateX(-50%) translateY(5px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
  visibility: hidden;

  &.is-copied {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s ease;
    visibility: visible;
  }
}

.confirmation__footer {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  text-align: center;
}

.confirmation__footer-link {
  color: var(--green--dark);
  display: flex;
  align-items: center;
  font-weight: 700;
}

.confirmation__footer-link-icon {
  margin-right: 10px;
}
</style>
